export default {
  navigationBarTitleText: '线索详情'
};
